export default __webpack_public_path__ + "static/media/Impeller Wheel.c42522e8.jpg";